import { Col, Glyphicon, Grid, Row } from 'react-bootstrap'
import { getMXDewarsByProposal, updateShippingStatus } from '../../api/ispyb'

import Button from 'react-bootstrap/lib/Button'
import { ERROR_MESSAGE_TYPE } from '../../constants/UserMessages'
import Loader from 'react-loader-advanced'
import MXNavigationContainer from './MXNavigationContainer'
import MXStepContainer from './MXStepContainer'
import PropTypes from 'prop-types'
import React from 'react'
import ResponsiveTable from '../../components/Table/ResponsiveTable'
import UserMessage from '../../components/saxs/UserMessage'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import format from 'date-fns/format'
import groupBy from 'lodash/groupBy'
import parse from 'date-fns/parse'
import { setBreadCrumbs } from '../../actions/breadcrumbs'

require('./mxprepareexperiment.css')

const rowStyle = row => {
  if (row.shippingStatus === 'processing') {
    return { background: '#F7BE81' }
  }
  return {}
}

class MXExperimentsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      fetched: false,
      fetching: true,
      response: null,
      displayAll: false,
      filtered: null,
      step: 1,
    }
    this.displayProcessing = this.displayProcessing.bind(this)
  }

  filterDuplicate(data) {
    const flags = []
    const output = []
    const l = data.length
    let i
    for (i = 0; i < l; i++) {
      if (flags[data[i].shippingId]) continue
      flags[data[i].shippingId] = true
      output.push(data[i])
    }
    return output
  }

  componentDidMount() {
    const _this = this
    axios({
      method: 'GET',
      url: getMXDewarsByProposal(this.props.user, this.props.application.activeProposal.name),
    }).then(
      response => {
        _this.setState({
          response: response.data,
          filtered: _this.filterDuplicate(response.data),
          fetching: false,
          fetched: true,
          url: this.props.url,
          step: 1,
        })
      },
      error => {
        _this.setState({ error: error, fetching: false, fetched: false, step: 1 })
      }
    )
  }

  displayProcessing(event) {
    const target = event.target
    const value = target.checked
    const name = target.name
    if (target.checked) {
      const tmp = this.filterDuplicate(this.state.response)
      const now = new Date()
      const output = []
      const l = tmp.length
      let i
      for (i = 0; i < l; i++) {
        if (new Date(tmp[i].sessionStartDate).getTime() > now.getTime() || tmp[i].shippingStatus === 'processing') {
          output.push(tmp[i])
        }
      }
      this.setState({ filtered: output })
    } else {
      this.setState({ filtered: this.filterDuplicate(this.state.response) })
    }
    this.setState({
      [name]: value,
    })
  }

  render() {
    if (this.props.user.username === null || this.props.user.token === null) {
      return null
    }
    if (this.state.fetching) {
      return (
        <Loader show={this.state.fetching} message="Fetching data">
          ..
        </Loader>
      )
    }

    if (this.state.fetched === false && this.state.fetching === false) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <UserMessage type={ERROR_MESSAGE_TYPE} message="Retrieval of the data failed." />
            </Col>
          </Row>
        </Grid>
      )
    }

    return (
      <div>
        <MXStepContainer step={this.state.step} />

        <div className="text-container-default">
          <label>
            {this.state.filtered.length} shipments candidate for {this.props.application.activeProposal.name}
          </label>
        </div>
        <div style={{ margin: '30px', marginTop: '5px' }}>
          <input name="displayAll" type="checkbox" checked={this.state.displayAll} onChange={this.displayProcessing} />
          <label style={{ paddingLeft: '5px' }}>
            Display only shipments scheduled for future sessions or in processing status
          </label>
        </div>
        <div style={{ margin: '30px', marginBottom: '5px' }}>
          <ResponsiveTable
            rowStyle={rowStyle}
            pageOptions={{
              sizePerPage: 25,
            }}
            search={false}
            keyField="id"
            data={this.state.filtered}
            {...this.props.baseProps}
            columns={this.getColumns()}
          />
        </div>
        <MXNavigationContainer step={this.state.step} />
      </div>
    )
  }

  dateFormatter(cell) {
    if (!cell) {
      return ''
    }
    return format(parse(cell, 'MMM d, yyyy h:mm:ss aaa', new Date()), 'dd/MM/yyyy')
  }

  addAction(cell, row, rowIndex, extraData) {
    if (row.shippingStatus !== 'processing') {
      return (
        <Button onClick={() => extraData.handleClickAdd(row)}>
          <Glyphicon glyph="plus-sign" />
        </Button>
      )
    }
    return (
      <Button disabled onClick={() => extraData.handleClickAdd(row)}>
        <Glyphicon glyph="plus-sign" />
      </Button>
    )
  }

  removeAction(cell, row, rowIndex, extraData) {
    if (row.shippingStatus === 'processing') {
      return (
        <Button onClick={() => extraData.handleClickRemove(row)}>
          <Glyphicon glyph="remove-sign" />
        </Button>
      )
    }
    return (
      <Button disabled onClick={() => extraData.handleClickRemove(row)}>
        <Glyphicon glyph="remove-sign" />
      </Button>
    )
  }

  handleClickAdd(row) {
    const url = updateShippingStatus(
      this.props.user,
      this.props.application.activeProposal.name,
      row.shippingId,
      'processing'
    )
    this.update(url)
  }

  handleClickRemove(row) {
    const url = updateShippingStatus(
      this.props.user,
      this.props.application.activeProposal.name,
      row.shippingId,
      'at_SOLEIL'
    )
    this.update(url)
  }

  update(url) {
    axios({
      method: 'GET',
      url: url,
    })
      .then(() => {})
      .then(() => this.componentDidMount())
  }

  getColumns() {
    return [
      {
        text: 'id',
        dataField: 'id',
        hidden: true,
      },
      {
        text: 'Name',
        dataField: 'shippingName',
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
          sm: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
          md: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
          lg: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Status',
        dataField: 'shippingStatus',
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '60px',
            textAlign: 'center',
          },
          sm: {
            width: '60px',
            textAlign: 'center',
          },
          md: {
            width: '60px',
            textAlign: 'center',
          },
          lg: {
            width: '60px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Created on',
        dataField: 'creationDate',
        formatter: this.dateFormatter,
        formatExtraData: this,
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '100px',
            textAlign: 'center',
          },
          sm: {
            width: '100px',
            textAlign: 'center',
          },
          md: {
            width: '80px',
            textAlign: 'center',
          },
          lg: {
            width: '80px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Start on',
        dataField: 'sessionStartDate',
        formatter: this.dateFormatter,
        formatExtraData: this,
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '100px',
            textAlign: 'center',
          },
          sm: {
            width: '100px',
            textAlign: 'center',
          },
          md: {
            width: '80px',
            textAlign: 'center',
          },
          lg: {
            width: '80px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Beamline',
        dataField: 'beamlineName',
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '60px',
            textAlign: 'center',
          },
          sm: {
            width: '60px',
            textAlign: 'center',
          },
          md: {
            width: '60px',
            textAlign: 'center',
          },
          lg: {
            width: '60px',
            textAlign: 'center',
          },
        },
      },

      {
        text: '',
        dataField: 'sampleCount',
        formatter: this.proposalFormatter2,
        formatExtraData: this.state.response,
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '100px',
            textAlign: 'center',
          },
          sm: {
            width: '100px',
            textAlign: 'center',
          },
          md: {
            width: '100px',
            textAlign: 'center',
          },
          lg: {
            width: '100px',
            textAlign: 'center',
          },
        },
      },
      {
        text: '',
        dataField: 'action_add',
        formatter: this.addAction,
        formatExtraData: this,
        responsiveHeaderStyle: {
          xs: {
            width: '60px',
            textAlign: 'center',
          },
          sm: {
            width: '60px',
            textAlign: 'center',
          },
          md: {
            width: '60px',
            textAlign: 'center',
          },
          lg: {
            width: '60px',
            textAlign: 'center',
          },
        },
      },

      {
        text: '',
        dataField: 'action_remove',
        formatter: this.removeAction,
        formatExtraData: this,
        responsiveHeaderStyle: {
          xs: {
            width: '60px',
            textAlign: 'center',
          },
          sm: {
            width: '60px',
            textAlign: 'center',
          },
          md: {
            width: '60px',
            textAlign: 'center',
          },
          lg: {
            width: '60px',
            textAlign: 'center',
          },
        },
      },
    ]
  }

  proposalFormatter2(cell, row, rowIndex, extraData) {
    if (cell !== null) {
      const containers = filter(extraData, function (e) {
        return e.shippingId === row.shippingId
      })
      let sampleCount = 0
      containers.forEach(function (value) {
        sampleCount = sampleCount + value.sampleCount
      })
      const stats = {
        samples: sampleCount,
        dewars: Object.keys(groupBy(containers, 'dewarId')).length,
        containers: containers.length,
      }

      return stats.dewars + ' parcels / ' + stats.containers + ' containers (' + stats.samples + ' samples)'
      // return ""
    }
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MXExperimentsContainer)

MXExperimentsContainer.propTypes = {
  /** proposal number */
  proposal: PropTypes.string,
  /** session identifier */
  sessionId: PropTypes.string,
}
